import DropDown from './DropDown';
import { Link } from 'react-router-dom';

export default function Nav({ setMobileToggle }) {
  return (
    <ul className="cs_nav_list fw-medium">
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Home
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Sobre
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Tráfego Pago
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Google Ads
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Facebook Ads
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Consultoria
        </Link>
      </li>
    </ul>
  );
}
